<div class="component-textarea-box type-{{type}}" id="box-{{id}}" >
<!--  <textarea id="component-textarea-{{id}}" placeholder="{{placeholder}}" [maxLength]="maxLen" (input)="autoTextarea(id)" (focus)="autoTextarea(id)" (change)="autoTextarea(id)"></textarea>-->
  <pre id="fit1-{{questionId}}-{{id}}" class="fit1 hide"></pre>
  <textarea id="component-textarea-{{questionId}}-{{id}}" placeholder="{{placeholder}}" [maxLength]="realMaxLen" (input)="outPutTextareaVal($event)" (change)="autoTextarea($event,'change')" (focus)="autoTextarea($event,'focus')" >{{textareaValue}}</textarea>
  <span class="component-word-limit" id="word-limit-{{id}}" *ngIf="isShowWordLimit">{{wordCount}}/{{maxLen}}</span>
</div>




// WEBPACK FOOTER //
// ./src/component/textarea/component.textarea.html